const SHIPPING_ERROR_MESSAGES = {
  address1: 'Please, enter a valid address',
  address2: 'Please, enter a valid address',
  city: 'Please, enter a valid city',
  state: 'Please, enter a valid state',
  zipCode: 'Please, enter a valid zipCode',
};

/**
 * Temporary handle address validation on UI based on API (USPS row response)
 */
const address1KeyMap = {
  address1: 'address',
  city: 'city',
  state: 'state',
  zipCode: 'zipcode',
};
const address2KeyMap = {
  address2: 'address',
  city: 'city',
  state: 'state',
  zipCode: 'zipcode',
};

const DEFAULT_ERROR_MESSAGE = 'Address Not Found.';

const createErrors = (message = '', addressKeysMap) => {
  const errors = Object.entries(addressKeysMap).reduce((acc, [key, value]) => {
    if (message.toLowerCase().indexOf(value) > -1) {
      acc[key] = SHIPPING_ERROR_MESSAGES[key];
    }
    return acc;
  }, {});
  return Object.keys(errors).length ? errors : null;
};

export const modifyAddressResponse = ({ deliverability, corrected, address, message = DEFAULT_ERROR_MESSAGE }) => {
  if (deliverability === 'undeliverable') {
    return {
      isValid: false,
      errors: createErrors(message, address1KeyMap),
      message,
    };
  }
  if (deliverability === 'deliverable_missing_secondary' || deliverability === 'deliverable_incorrect_secondary') {
    return {
      isValid: false,
      errors: createErrors(message, address2KeyMap),
      message,
    };
  }
  return {
    isValid: true,
    address,
    corrected,
  };
};

export const getShippingAddress = (plans, checkout) => {
  if (checkout.hasShippingAddress && plans.isPlanSelected && plans.selectedPlan.hasMerchandise) {
    return checkout.shippingAddress;
  }
  return undefined;
};
